/**
 * @generated SignedSource<<15eb34cbfcaeea0faf712c360db36942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligencePage_Query$variables = Record<PropertyKey, never>;
export type diligencePage_Query$data = {
  readonly diligence: {
    readonly annualPnl: {
      readonly afterDistributions: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly categories: ReadonlyArray<{
        readonly byYear: ReadonlyArray<{
          readonly value: number | null | undefined;
          readonly year: number;
        }>;
        readonly category: {
          readonly id: string;
        } | null | undefined;
        readonly name: string;
        readonly pnlLine: string;
        readonly subcategories: ReadonlyArray<{
          readonly byYear: ReadonlyArray<{
            readonly value: number | null | undefined;
            readonly year: number;
          }>;
          readonly category: {
            readonly id: string;
          } | null | undefined;
          readonly name: string;
        }>;
      }>;
      readonly cogs: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly debtYearEnd: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly distributions: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly ebitda: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly ebitdaMargin: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly gAndA: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly grossMargin: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly grossProfit: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly interestAndFees: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly loanPrincipalRepaid: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly loanProceeds: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly rAndD: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly revenue: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly revenueGrowth: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly sAndM: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly taxPaid: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly taxes: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly uncategorized: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly years: ReadonlyArray<number>;
    };
    readonly arrByYear: ReadonlyArray<{
      readonly value: number | null | undefined;
      readonly year: number;
    }>;
    readonly currentArr: number | null | undefined;
    readonly qboPnl: {
      readonly basis: string;
      readonly cogs: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly connected: boolean;
      readonly grossProfit: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly marketing: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly marketingAccounts: ReadonlyArray<{
        readonly byYear: ReadonlyArray<{
          readonly value: number | null | undefined;
          readonly year: number;
        }>;
        readonly name: string | null | undefined;
      }>;
      readonly marketingQbo: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly marketingReclass: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly marketingStakeholders: ReadonlyArray<{
        readonly byYear: ReadonlyArray<{
          readonly value: number | null | undefined;
          readonly year: number;
        }>;
        readonly name: string;
        readonly stakeholder: {
          readonly id: string;
        } | null | undefined;
        readonly total: number;
      }>;
      readonly netIncome: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly otherOpex: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly revenue: ReadonlyArray<{
        readonly value: number | null | undefined;
        readonly year: number;
      }>;
      readonly years: ReadonlyArray<number>;
    };
    readonly retention: {
      readonly bySeat: ReadonlyArray<{
        readonly band: string;
        readonly baseCount: number;
        readonly grr: number | null | undefined;
        readonly logoRetention: number | null | undefined;
        readonly nrr: number | null | undefined;
      }>;
      readonly byTenure: ReadonlyArray<{
        readonly band: string;
        readonly baseCount: number;
        readonly grr: number | null | undefined;
        readonly logoRetention: number | null | undefined;
        readonly nrr: number | null | undefined;
      }>;
      readonly global: {
        readonly band: string;
        readonly baseCount: number;
        readonly curCount: number;
        readonly grr: number | null | undefined;
        readonly logoRetention: number | null | undefined;
        readonly nrr: number | null | undefined;
      };
    };
    readonly retentionSeries: {
      readonly seat: {
        readonly mom: ReadonlyArray<{
          readonly band: string;
          readonly points: ReadonlyArray<{
            readonly grr: number | null | undefined;
            readonly logoChurn: number | null | undefined;
            readonly logoChurnCancellations: number | null | undefined;
            readonly month: any;
            readonly nrr: number | null | undefined;
          }>;
        }>;
        readonly ttm: ReadonlyArray<{
          readonly band: string;
          readonly points: ReadonlyArray<{
            readonly grr: number | null | undefined;
            readonly logoChurn: number | null | undefined;
            readonly logoChurnCancellations: number | null | undefined;
            readonly month: any;
            readonly nrr: number | null | undefined;
          }>;
        }>;
      };
      readonly tenure: {
        readonly mom: ReadonlyArray<{
          readonly band: string;
          readonly points: ReadonlyArray<{
            readonly grr: number | null | undefined;
            readonly logoChurn: number | null | undefined;
            readonly logoChurnCancellations: number | null | undefined;
            readonly month: any;
            readonly nrr: number | null | undefined;
          }>;
        }>;
        readonly ttm: ReadonlyArray<{
          readonly band: string;
          readonly points: ReadonlyArray<{
            readonly grr: number | null | undefined;
            readonly logoChurn: number | null | undefined;
            readonly logoChurnCancellations: number | null | undefined;
            readonly month: any;
            readonly nrr: number | null | undefined;
          }>;
        }>;
      };
    };
  };
};
export type diligencePage_Query = {
  response: diligencePage_Query$data;
  variables: diligencePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentArr",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "year",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "arrByYear",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "years",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "revenue",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "cogs",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "grossProfit",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "byYear",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AnnualPnl",
  "kind": "LinkedField",
  "name": "annualPnl",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "grossMargin",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "sAndM",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "rAndD",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "gAndA",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "uncategorized",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "ebitda",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "ebitdaMargin",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "revenueGrowth",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "taxes",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "taxPaid",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "interestAndFees",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "loanProceeds",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "loanPrincipalRepaid",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "distributions",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "afterDistributions",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "YearMetric",
      "kind": "LinkedField",
      "name": "debtYearEnd",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnualPnlCategory",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pnlLine",
          "storageKey": null
        },
        (v10/*: any*/),
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AnnualPnlCategory",
          "kind": "LinkedField",
          "name": "subcategories",
          "plural": true,
          "selections": [
            (v7/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basis",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "marketing",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "marketingQbo",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "marketingReclass",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "otherOpex",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "YearMetric",
  "kind": "LinkedField",
  "name": "netIncome",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "band",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nrr",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grr",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoRetention",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baseCount",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "curCount",
  "storageKey": null
},
v28 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoChurn",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoChurnCancellations",
  "storageKey": null
},
v32 = [
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionPoint",
    "kind": "LinkedField",
    "name": "points",
    "plural": true,
    "selections": [
      (v29/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/)
    ],
    "storageKey": null
  }
],
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionLine",
    "kind": "LinkedField",
    "name": "ttm",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionLine",
    "kind": "LinkedField",
    "name": "mom",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  }
],
v34 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v8/*: any*/)
],
v35 = [
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionPoint",
    "kind": "LinkedField",
    "name": "points",
    "plural": true,
    "selections": [
      (v29/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  (v8/*: any*/)
],
v36 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionLine",
    "kind": "LinkedField",
    "name": "ttm",
    "plural": true,
    "selections": (v35/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RetentionLine",
    "kind": "LinkedField",
    "name": "mom",
    "plural": true,
    "selections": (v35/*: any*/),
    "storageKey": null
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligencePage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Diligence",
        "kind": "LinkedField",
        "name": "diligence",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QboPnl",
            "kind": "LinkedField",
            "name": "qboPnl",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QboPnlAccount",
                "kind": "LinkedField",
                "name": "marketingAccounts",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingStakeholder",
                "kind": "LinkedField",
                "name": "marketingStakeholders",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetentionSegments",
            "kind": "LinkedField",
            "name": "retention",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "global",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "bySeat",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "byTenure",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetentionSeries",
            "kind": "LinkedField",
            "name": "retentionSeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionDimensionSeries",
                "kind": "LinkedField",
                "name": "seat",
                "plural": false,
                "selections": (v33/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionDimensionSeries",
                "kind": "LinkedField",
                "name": "tenure",
                "plural": false,
                "selections": (v33/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "diligencePage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Diligence",
        "kind": "LinkedField",
        "name": "diligence",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QboPnl",
            "kind": "LinkedField",
            "name": "qboPnl",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QboPnlAccount",
                "kind": "LinkedField",
                "name": "marketingAccounts",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingStakeholder",
                "kind": "LinkedField",
                "name": "marketingStakeholders",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v11/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetentionSegments",
            "kind": "LinkedField",
            "name": "retention",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "global",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "bySeat",
                "plural": true,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionRow",
                "kind": "LinkedField",
                "name": "byTenure",
                "plural": true,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RetentionSeries",
            "kind": "LinkedField",
            "name": "retentionSeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionDimensionSeries",
                "kind": "LinkedField",
                "name": "seat",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RetentionDimensionSeries",
                "kind": "LinkedField",
                "name": "tenure",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f88057a34d4176e2c57c7bfd15943a3a",
    "id": null,
    "metadata": {},
    "name": "diligencePage_Query",
    "operationKind": "query",
    "text": "query diligencePage_Query {\n  diligence {\n    currentArr\n    arrByYear {\n      year\n      value\n    }\n    annualPnl {\n      years\n      revenue {\n        year\n        value\n      }\n      cogs {\n        year\n        value\n      }\n      grossProfit {\n        year\n        value\n      }\n      grossMargin {\n        year\n        value\n      }\n      sAndM {\n        year\n        value\n      }\n      rAndD {\n        year\n        value\n      }\n      gAndA {\n        year\n        value\n      }\n      uncategorized {\n        year\n        value\n      }\n      ebitda {\n        year\n        value\n      }\n      ebitdaMargin {\n        year\n        value\n      }\n      revenueGrowth {\n        year\n        value\n      }\n      taxes {\n        year\n        value\n      }\n      taxPaid {\n        year\n        value\n      }\n      interestAndFees {\n        year\n        value\n      }\n      loanProceeds {\n        year\n        value\n      }\n      loanPrincipalRepaid {\n        year\n        value\n      }\n      distributions {\n        year\n        value\n      }\n      afterDistributions {\n        year\n        value\n      }\n      debtYearEnd {\n        year\n        value\n      }\n      categories {\n        name\n        pnlLine\n        category {\n          id\n        }\n        byYear {\n          year\n          value\n        }\n        subcategories {\n          name\n          category {\n            id\n          }\n          byYear {\n            year\n            value\n          }\n        }\n      }\n    }\n    qboPnl {\n      connected\n      basis\n      years\n      revenue {\n        year\n        value\n      }\n      cogs {\n        year\n        value\n      }\n      grossProfit {\n        year\n        value\n      }\n      marketing {\n        year\n        value\n      }\n      marketingQbo {\n        year\n        value\n      }\n      marketingReclass {\n        year\n        value\n      }\n      otherOpex {\n        year\n        value\n      }\n      netIncome {\n        year\n        value\n      }\n      marketingAccounts {\n        name\n        byYear {\n          year\n          value\n        }\n        id\n      }\n      marketingStakeholders {\n        name\n        stakeholder {\n          id\n        }\n        total\n        byYear {\n          year\n          value\n        }\n        id\n      }\n      id\n    }\n    retention {\n      global {\n        band\n        nrr\n        grr\n        logoRetention\n        baseCount\n        curCount\n        id\n      }\n      bySeat {\n        band\n        nrr\n        grr\n        logoRetention\n        baseCount\n        id\n      }\n      byTenure {\n        band\n        nrr\n        grr\n        logoRetention\n        baseCount\n        id\n      }\n      id\n    }\n    retentionSeries {\n      seat {\n        ttm {\n          band\n          points {\n            month\n            nrr\n            grr\n            logoChurn\n            logoChurnCancellations\n            id\n          }\n          id\n        }\n        mom {\n          band\n          points {\n            month\n            nrr\n            grr\n            logoChurn\n            logoChurnCancellations\n            id\n          }\n          id\n        }\n        id\n      }\n      tenure {\n        ttm {\n          band\n          points {\n            month\n            nrr\n            grr\n            logoChurn\n            logoChurnCancellations\n            id\n          }\n          id\n        }\n        mom {\n          band\n          points {\n            month\n            nrr\n            grr\n            logoChurn\n            logoChurnCancellations\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "014e58ae012d6ecb5b6e68dff9b7538d";

export default node;
